<ng-container>
  @if (_editableGridData && _editableGridData.bookmarks) {
    @if (_editableGridData.config != undefined && _editableGridData.config.filterAr != undefined && _editableGridData.config.filterAr.length) {
    <div class="bookmarks-container ml-2 mr-2">
        <div class="col-12 p-0">
            @for (filter of _editableGridData.config.filterAr; track filter) {
            <div class="fav-bookmark">
                <div class="bookmark-chip" [ngClass]="(_editableGridData.config!=undefined && _editableGridData.config.filterConfig!=undefined && _editableGridData.config.filterConfig.FilterName!=undefined) && (filter.name == _editableGridData.config.filterConfig.FilterName) ? 'active': ''" style="cursor: pointer;">
                    <span class="" (click)="applyFilter(filter)"> {{ filter.name }}</span>
                    <!-- <i class="fa fa-filter" (click)="applyFilter(filter)"></i> -->
                    <!-- (click)="resetFilter(filter)" -->
                    @if ((_editableGridData.config!=undefined && _editableGridData.config.filterConfig!=undefined && _editableGridData.config.filterConfig.FilterName!=undefined) && (filter.name ==_editableGridData.config.filterConfig.FilterName)) {
                    <i class="fa fa-check ml-1"></i>
                    }
                </div>
            </div>
            }
            @if (_editableGridData.config.localStorageData && _editableGridData.config.localStorageData['filter__'] != undefined && _editableGridData.config.localStorageData['filter__'].length >0) {
            <a href="javascript:void(0)" title="Manage Filters" (click)="manageFilter()" class="_fav-3-dots">
                <div class="_fav-3-dots-container">
                    <img src="assets/images/icon-context.svg">
                </div>
          </a>
            }
        </div>
    </div>
    }
    <!-- <app-bookmarks [bookmarks]="_editableGridData.bookmarks" (Entity)="bookmarkAdded($event,_editableGridData.bookmarks.bookmark.type)"></app-bookmarks> -->
  }
</ng-container>
<ng-container>
  @if (_editableGridData) {
    <div class="d-flex justify-content-end">
        <ng-container>
            @if (_editableGridData.add_new) {
            <button type="button" class="primary-btn"
                (click)="addRow(_editableGridData.items.length)">
                <span>{{'Add New' | translate | async}}</span>
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
            }
        </ng-container>
    </div>
    @if (_editableGridData.filter_block !=null || _editableGridData.listBlocks && showHideSearch() || searchConfig.barcode_config != undefined || _editableGridData.buttons && _editableGridData.buttons != undefined && _editableGridData.buttons.length>0 
        && _editableGridData.itemsCount != null &&  _editableGridData.itemsCount > 0) {
    <div class="row">
        <div class="table-action-container w-100">
            <div class="d-flex align-items-center">
                <ng-container>
                  @if (_editableGridData.barcode_reader) {
                    <div style="margin-right: 1%">
                        <input id="bar_{{i}}" autocomplete="off" autofocus (keydown.enter)="barcodeReader($event.target.value)"
                            type="textbox" [(ngModel)]="_editableGridData.barcodeReaderModel" placeholder="Enter barcode ..." class="form-control">
                    </div>
                  }
                </ng-container>
                <!-- <div *ngIf="_editableGridData.filter_block !=null">
                    <button type="button" class="secondary-btn" (click)="displayFilter()">
                        <span>{{'Filter' | translate | async}}</span>
                        <i class="fa fa-filter" aria-hidden="true"></i>
                    </button>
                </div> -->
                @if (_editableGridData.filter_block !=null) {
                <div class="_filter-button-wrapper">
                    <ng-container>
                        <div class="_filter-button d-flex align-items-center" (click)="displayFilter()">
                            @if (!showHideSearch()) {
                            <span class="filter-buttonname d-inline">{{'Filter' | translate |
                                async}}</span>
                            }
                            <i class="fa fa-filter" aria-hidden="true"></i>
                        </div>
                    </ng-container>
                </div>
                }
                <div class="w-100-mobile">
                    <!------Action buttons------------------------------------------------>
                    <!-- <ng-container>
                        <button type="button" *ngIf="_editableGridData.add_new" class="primary-btn" (click)="addRow(_editableGridData.items.length)">
                            <span>{{'Add New' | translate | async}}</span>
                            <i class="fa fa-plus" aria-hidden="true"></i>tile
                        </button>
                    </ng-container> -->
                    <!------Common Search box------------------------------------------------>
                    @if (_editableGridData.listBlocks && _editableGridData.listBlocks.hasOwnProperty('APIresource') && showHideSearch() && !_editableGridData.hide_search) {
                    <div class="grid-search-wrapper"
                        [ngClass]="_editableGridData.filter_block !=null ? 'has-filter' : '' ">
                        <div class="grid-smart-search-container mr-2 w-100-mobile">

                            <!-- <div class="grid-smart-search-container d-flex align-items-center"> -->
                            <app-complex-search [config]="searchConfig" (onFilterChange)="filterClick($event);"
                                class="w-100-mobile">
                            </app-complex-search>
                            <!-- <span class="grid-smart-search" id="basic-addon2" (click)="onFilterClick($event)"><i
                                    class="fa fa-search" aria-hidden="true"></i></span>
                                <input type="text" class="search form-control" pattern="[^A-Za-z0-9]" [(ngModel)]="_editableGridData.filterStr" placeholder="Search" (keydown)="onFilter($event)"> -->
                            <!-- </div> -->
                        </div>
                    </div>
                    }
                </div>
                <div class="ml-auto" [ngClass]="{'d-flex align-items-center': _editableGridData.toggle_button}">
                    @if (_editableGridData.toggle_button) {
                    <div class="toggle-button" (click)="onToggleButton()">
                        <span class="toggle-button-track" [class.on]="toggleButtonOn">
                            <span class="toggle-button-knob"></span>
                        </span>
                        <span class="toggle-button-label">{{_editableGridData.toggle_button.label | translate | async}}</span>
                    </div>
                    }
                    @if (!utilService.isMobile()) {
                    <div class="top-pagination" [hidden]="!_editableGridData.paging && _editableGridData.itemsCount>0">
                        <div [hidden]="!_editableGridData.paging" class="d-flex">
                            @if (_editableGridData.itemsCount || _editableGridData.noCount) {
                            <dhs-pagination #pagination
                                [gridConfig]="_editableGridData" [itemsCount]="_editableGridData.itemsCount"
                                [itemsCount]="_editableGridData.itemsCount" [limit]="_editableGridData.page_size"
                                [startPage]="_editableGridData.page_no+1" (pageChange)="onPageChanged($event)"
                                (onLimitChanges)="onLimit($event.target.value)" class="d-flex"
                                (onConfigChanges)="pageConfigChange($event)">
                            </dhs-pagination>
                            }
                            <!-- <ng-container *ngIf="!utilService.isMobile() && _editableGridData.noCount && this._editableGridData.items.length>0">
                                ss
                                <a class="get-count-link-button" (click)="getCount()" href="javascript:void(0);" title="Get Count"> 
                                    sp
                                    <button type="button" class="btn-with-img-icon-label">
                                        <img src="assets/images/icons/get-count-icon.svg"/>
                                        <span># Count</span>
                                    </button>
                                </a>
                            </ng-container> -->
                        </div>
                    </div>
                    }

                </div>
                <!-- <div class="table-quick-actions">
                    <ng-template #showWarnigs>
                        Remove Sorting
                    </ng-template>
                    <div [popover]="showWarnigs" containerClass="info-popover" triggers="click" container="body" class="blinking-icon btn-with-icon-label"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
                </div> -->
                <ng-container>
                  @if ((searchConfig && searchConfig.barcode_config && searchConfig.barcode_config.datasource) || (searchConfig?.barcode_config?.performActionOnScan)) {
                    <div>
                        <button type="button"
                            [ngClass]="(_editableGridData.barcodeConfig != undefined && (_editableGridData.barcodeConfig.populateGrid == true || _editableGridData.barcodeConfig.performActionOnScan)) ? 'btn-with-icon-label-round-back' : 'btn-with-icon-label'"
                            (click)="toggleBarcodeScan()">
                            @if (searchConfig.barcode_config != undefined) {
                            <div>
                                <div tabindex="0" (keydown.enter)="toggleBarcodeScan()">
                                    <i aria-hidden="true" class="fa fa-barcode"></i>
                                </div>
                                <span>{{'Scan' | translate | async}}</span>
                                
                            </div>
                            }
                        </button>
                    </div>
                  }
                </ng-container>
                <div class="table-quick-actions">
                    @if (_editableGridData.buttons && _editableGridData.buttons != undefined && _editableGridData.buttons.length>0 
                         && _editableGridData.itemsCount != null &&  _editableGridData.currentItemCount > 0) {
                    <div class="">
                        @for (buttons of _editableGridData.buttons; track buttons) {
                        <button type="button" class="btn-with-icon-label" (click)="onButtonClicked(buttons)">
                            <i aria-hidden="true" [class]="buttons.class_name"></i>
                            <span>
                                {{buttons.label | translate | async}}
                            </span>
                        </button>
                        }
                    </div>
                    }
                    @if (_editableGridData.allowEditGridDownload && _editableGridData.new_buttons && _editableGridData.new_buttons != undefined && _editableGridData.new_buttons.length>0 
                                                                && _editableGridData.itemsCount != null &&  _editableGridData.itemsCount > 0) {
                    <div class="">
                        <ng-container>
                          @for (buttons of _editableGridData.new_buttons; track buttons) {
                            <button type="button" class="btn-with-icon-label" (click)="onButtonClicked(buttons)">
                                <i aria-hidden="true" [class]="buttons.class_name"></i>
                                <span>
                                    {{buttons.label | translate | async}}
                                </span>
                            </button>
                          }
                        </ng-container>
                    </div>
                    }
                    <div>
                        @if (_editableGridData.allowConfigGrid && rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                        <button
                            type="button" class="btn-with-icon-label" (click)="configureGrid()">
                            <i aria-hidden="true" class="fa fa-cog"></i>
                            <span>
                                {{'cg' | translate | async}}
                            </span>
                        </button>
                        }
                    </div>
                    <div>
                        @if (_editableGridData.master_upload && rolePermissionService.checkAccessPermission(_editableGridData.master_upload.action || 'modify', _editableGridData.master_upload.permission_resource || 'master_upload','data-onboarding')) {
                        <button type="button" class="btn-with-icon-label" (click)="openMasterUpload()">
                            <i aria-hidden="true" class="fa fa-upload"></i>
                            <span>
                                {{(_editableGridData.master_upload.label != undefined ? _editableGridData.master_upload.label : 'menu.master_upload') | translate | async}}
                            </span>
                        </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @if (_editableGridData.filter_block) {
    <div class="row filter-grid">
        <div class="col-12 pl-4 pr-4" [hidden]="!_editableGridData.filter">
            <div class="grid_filter">
                <div class="filter-body">
                    <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
                    <span class="close-filter-btn" (click)="displayFilter()">
                        <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                    <div class="filter-form">
                        <kx-filter (getData)="getDataFn($event)" [config]="_editableGridData.config" [fields]="_editableGridData.filter_block" [persistValue]="searchConfig"  (getFilter)="doSearch($event)" (resetFilter)="resetFilter($event, true)" (resetQuickFilter)="resetQuickFilter()" #kxFilter>
                        </kx-filter>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    <div class="_mobile-pagination-count-wrapper col-12">
        <div>
            @if (_editableGridData.selectall) {
            <div>
                <div class="custom-control custom-switch table-switch bulk-action-mobile">
                    <input class="custom-control-input " id="{{resource ? resource :'customSwitch2'}}"
                        type="checkbox" (change)="onAllChecked($event.target.checked)"
                        [checked]="obj_table.length === selectedItems.length && obj_table.length > 0"
                        >
                    <label class="custom-control-label" for="{{resource ? resource :'customSwitch2'}}">
                    </label>
                    <p class="m-0 p-0">Select All</p>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="col-12 grid-container p-0">
        @if (editableTable) {
        <form [formGroup]="editableTable">
            @if (this._editableGridData['activeField'] == 'table') {
            <div class="table-responsive" id="scroll-to-initial">
                @if (_editableGridData.fields) {
                <table class="table table-hover" id="editable-grid">
                    <thead>
                        <tr>
                            @if (_editableGridData.selectall) {
                            <th scope="col" class="editable-th-checkbox">
                                <label class="check-wrapper">
                                    @if (_editableGridData.items) {
                                    <input (change)="onAllChecked($event.target.checked)"
                                        [disabled]="_editableGridData.checkboxCondition"
                                        [checked]="obj_table.length === selectedItems.length && obj_table.length > 0"
                                        type="checkbox" class="checkbox">
                                    }
                                    <span class="check-mark"
                                        [ngClass]="_editableGridData.checkboxCondition?'disabled':null"></span>
                                </label>


                            </th>
                            }
                            @if (_editableGridData.index) {
                                <th class="index-column">#</th>
                            }
                            @if (_editableGridData.barcodeConfig && _editableGridData.barcodeConfig.isBarcodeText) {
                            <th>
                                <span>{{ 'Bar Code' | translate | async}} <i class="fa fa-barcode"></i></span>
                            </th>
                            }
                            <ng-container>
                              @for (field of _editableGridData.fields; track field; let lst=$last) {
                                @if (field.controlType !='hidden' && !field.hidden) {
                                <th scope="col"
                                    [attr.data-name]="field.key">
                                    <ng-container>
                                      @if (field.label !=false) {
                                        <div class="th-editable-grid________{{field.key}}" style="display: flex;align-items: center;">
                                            @if (field.sortable!=undefined && field.sortable) {
                                            <span
                                                (click)="onSort(field)" [ngClass]="{'fa-sort': !currentSort.get(field.key),
                                        'fa-sort-desc': currentSort.get(field.key) === -1,
                                        'fa-sort-asc': currentSort.get(field.key) === 1
                                    }" class="fa fa-sort kx-table-sort">&nbsp;&nbsp;
                                            </span>
                                            }
                                            @if (currentSort && (currentSort.get(field.key) === -1 || currentSort.get(field.key) === 1)) {
                                            <span [sharedPopover]="'Remove Sorting'"
                                                class="fa fa-times-circle-o editable-remove-sorting"
                                                (click)="clearSort()">
                                                &nbsp;&nbsp;
                                            </span>
                                            }
                                            <label [ngClass]="field.required?'required':''">{{ field.label | translate |
                                                async}}
                                            </label>
                                            <!-- <span *ngIf="field.conversion" style="margin-top: -6px"> &nbsp;<i [ngClass]="field.conversion?'fa fa-info-circle':''"></i></span> -->
                                        </div>
                                        <!-- <sup *ngIf="field.required" class="req">*</sup> -->
                                      }
                                    </ng-container>
                                </th>
                                }
                              }
                            </ng-container>
                            <!-- {{_editableGridData.listBlocks | json}} -->
                            <!-- *ngIf="_editableGridData.listBlocks.actions" -->
                            <th scope="col" colspan="2" class="fixed-column">
                                @if (!this._editableGridData.cog && _editableGridData.listBlocks.actions) {
                                <span>{{ 'Action' | translate | async}}</span>
                                }
                                @if (this._editableGridData.cog) {
                                <i [popover]="popTemplate" class="fa fa-cog" container="self"
                                    containerClass="tabelcontextualmenu table-header-menu" [outsideClick]="true"
                                    placement="left top"></i>
                                }
                                <ng-template #popTemplate>
                                    <div class="pl-3 p-2 p-dropdown-item">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" [checked]="this._editableGridData.viewAll == true"
                                                (change)="HidetoggleVisibility($event.target.checked)"
                                                class="custom-control-input" id="customCheck" name="example1">
                                            <label class="custom-control-label" for="customCheck">{{'View All'
                                                |translate |async}}</label>
                                        </div>
                                    </div>
                                    <ng-container>
                                      @for (action of _editableGridData.fields; track action) {
                                        @if (action.label && action.key && action.controlType != 'hidden') {
                                        <div class="pl-3 p-2 p-dropdown-item">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" (change)="toggleVisibility($event,action)"
                                                    [disabled]="action.disabled_ && !action.hidden"
                                                    [checked]="action.selected" class="custom-control-input"
                                                    id="{{action.label}}">
                                                <label class="custom-control-label"
                                                    for="{{action.label}}">{{action.label | translate | async}}</label>
                                            </div>
                                        </div>
                                        }
                                      }
                                    </ng-container>
                                    <div class="pl-3 p-2 p-dropdown-item">
                                        <a href="javascript:void(0)" (click)="resetDefaultConfig()"> Reset to
                                            Default</a>
                                    </div>

                                </ng-template>
                            </th>
                        </tr>
                    </thead>
                    @if (_editableGridData.nestedFields.length > 0) {
                    <tbody>
                        <ng-container formArrayName="editableRows">
                          @for (group of getFormControls.controls; track group; let i=$index; let l=$last) {
                            <tr [formGroupName]="i" id="{{i}}">
                                @if (_editableGridData.selectall) {
                                <td scope="row" class="editable-tb-checkbox">
                                    <label class="check-wrapper">
                                        <input type="checkbox" class="checkbox"
                                            [disabled]="disableSingleItem(group.value)"
                                            (change)="onItemChecked($event.target.checked, i,group)"
                                            [checked]="selectedIndices[i]">
                                        <span class="check-mark"
                                            [ngClass]="disableSingleItem(group.value)?'disabled':null"></span>
                                    </label>
                                </td>
                                }
                                @if (_editableGridData.index) {
                                    <td class="index-column">
                                        {{ (_editableGridData.page_no * _editableGridData.page_size) + i + 1 }}
                                    </td>
                                }
                                <ng-container>
                                    @if (_editableGridData.barcodeConfig && _editableGridData.barcodeConfig.isBarcodeText) {
                                    <td>
                                        <input id="bar_{{i}}" autocomplete="off" autofocus
                                            style="max-width: 150px !important"
                                            (keydown.enter)="barcodeRowScan($event.target.value, i)" type="textbox"
                                            placeholder="Enter barcode ..." class="form-control barcode_row">
                                    </td>
                                    }
                                </ng-container>
                                <ng-container>
                                  @for (field of _editableGridData.nestedFields[i]; track field; let j=$index) {
                                    <ng-template #details>
                                        <!-----PopOver implementation-->
                                        @if (field && _editableGridData) {
                                        <span>{{getDetails(field['key'],i)}}</span>
                                        }
                                    </ng-template>
                                        <!-----PopOver implementation-->
                                        <ng-template #subs_details>
                                            @if (field && _editableGridData) {
                                            <span [innerHtml]="getSubsDetails(field['key'],i)"></span>
                                            }
                                        </ng-template>
                                    <td scope="row"
                                        [ngClass]="field.controlType =='hidden' || field.hidden ?'d-none':''">
                                        <ng-container [ngSwitch]="field.controlType">
                                            <ng-container>
                                              @switch (field.controlType) {
                                                @case ('label') {
                                                <!-- this  adds classes with no. spans   -->
                                                <ng-container>
                                                  @if (field.class_conditions &&  !field.grid_color_text && commonService.getClass(this._editableGridData.items[i],field.class_conditions)!=undefined && commonService.getClass(this._editableGridData.items[i],field.class_conditions)) {
                                                    <ng-container>
                                                      @for (class_ of commonService.getClass(this._editableGridData.items[i],field.class_conditions).split(' '); track class_) {
                                                        <span [ngClass]="class_"> </span>
                                                      }
                                                    </ng-container>
                                                  }
                                                </ng-container>
                                                @if (field.type == undefined) {
                                                <label
                                                    [controlName]="field.name"></label>
                                                }
                                                <!-- this span adds class for text color etc -->
                                                <span id="label_{{i}}" class="_table-cell {{getConversionClass(field)}}"
                                                    [ngClass]="field.grid_color_text!=undefined && field.grid_color_text && field.class_conditions?(this._editableGridData.items[i] | getClass:field.class_conditions):''">

                                                    @if (field.type === 'datetime') {
                                                    <span>
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                                                        dateTimeFormat) : ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'date') {
                                                    <span>
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                                                        dateFormat) : ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'time') {
                                                    <span>
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                                                        timeFormat) : ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'string' || field.type === 'String') {
                                                        @if (field.popover && getFormattedValue(i, field) && hoveredPopoverCell === field.key + '_' + i) {
                                                        <span class="{{field.key}}______{{i}}"
                                                            [popover]="details" placement="top"
                                                            container="self" triggers="mouseenter:mouseleave"
                                                            (mouseleave)="hoveredPopoverCell = null"
                                                            (click)="field.conversion?changeControls(field,i):return;">
                                                             {{ getFormattedValue(i, field) ? getFormattedValue(i, field) :
                                                            getDefaultValue(field)}}
                                                        </span>
                                                        } @else {
                                                        <span class="{{field.key}}______{{i}}"
                                                            (mouseenter)="field.popover && getFormattedValue(i, field) ? hoveredPopoverCell = field.key + '_' + i : null"
                                                            (click)="field.conversion?changeControls(field,i):return;">
                                                             {{ getFormattedValue(i, field) ? getFormattedValue(i, field) :
                                                            getDefaultValue(field)}}
                                                        </span>
                                                        }
                                                    }
                                                    @if (field.type === 'number') {
                                                    <span (click)="getAction(i,field)"
                                                        [ngClass]="field.class_conditions &&  !field.grid_color_text && commonService.getClass(this._editableGridData.items[i],field.class_conditions)!=undefined && commonService.getClass(this._editableGridData.items[i],field.class_conditions)">
                                                        {{ getFormattedValue(i, field) ? getFormattedValue(i, field) :(getFormattedValue(i, field) === ''?'':0)}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'monthYear') {
                                                    <span [ngClass]="field.class_conditions &&  !field.grid_color_text && commonService.getClass(this._editableGridData.items[i],field.class_conditions)!=undefined && commonService.getClass(this._editableGridData.items[i],field.class_conditions)">
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                                                        MonthYearFormat) : ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'composite') {
                                                    <span>
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field)) :
                                                        ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'boolean' || field.type === 'Boolean') {
                                                    <span>
                                                        {{ getFormattedValue(i, field) ? (getFormattedValue(i, field)) :
                                                        ''}}
                                                    </span>
                                                    }
                                                    @if (field.type === 'tat' || field.type === 'TAT') {
                                                    <span [ngClass]="field.tatClass">
                                                    </span>
                                                    }
                                                    @if (field.type === 'icon_pic') {
                                                    <span>
                                                        @for (image of field.image_conditions; track image) {
                                                        <ng-template #image_popover_data>
                                                            <span>{{image.popover_remark ? this._editableGridData.items[i][image.popover_remark] : image.popover_data| translate |async
                                                                }}</span>
                                                        </ng-template>
                                                        @if (checkBannerExpression(image.expression,this._editableGridData.items[i])) {
                                                        <img [popover]="field.show_popover?image_popover_data:''" class="Imageconditionflag" placement="top"
                                                            container="body" triggers="mouseenter:mouseleave" src="assets/images/{{image.path}}">
                                                        }
                                                        }
                                                    </span>
                                                    }
                                                </span>
                                                }
                                                @default {
                                                <dhs-form-question [action]="action" [validIn]="validIn"
                                                    [insideGrid]="'true'" [index]="i" [question]="field" [form]="group"
                                                    (valueChanged)="onValueChanged($event,group,i)">
                                                </dhs-form-question>
                                                }
                                                @case ('link') {
                                            <ng-container>
                                              @if (field.changeable) {
                                                @if (checkExpression(i, field)) {
                                                    @if (field.action_config && getFormattedValue(i, field) && field.action_config.popover) {
                                                    <a [popover]="subs_details" placement="right"
                                                    container="self" triggers="mouseenter:mouseleave" (click)="view_details(i,field)"
                                                    class="text-decor" style="white-space: nowrap;">
                                                    {{ getFormattedValue(i, field) ? (getFormattedValue(i, field).length > 30 ? getFormattedValue(i, field).slice(0, 30) + " ...     " : getFormattedValue(i, field)) :'Search'}}
                                                    </a>
                                                    } @else {
                                                    <a (click)="view_details(i,field)"
                                                    class="text-decor" style="white-space: nowrap;">
                                                    {{ getFormattedValue(i, field) ? (getFormattedValue(i, field).length > 30 ? getFormattedValue(i, field).slice(0, 30) + " ...     " : getFormattedValue(i, field)) :'Search'}}
                                                    </a>
                                                    }
                                                }
                                            @if (getFormattedValue(i, field)) {
                                            <i aria-hidden="true" (click)="removeSubstitute(i,field)" class="fa fa-times-circle cursor-pointer"></i>
                                            }
                                              }
                                            </ng-container>
                                            <ng-container>
                                              @if (!field.changeable) {
                                                @if (checkExpression(i, field)) {
                                                <a (click)="view_details(i,field)"
                                                    class="text-decor">
                                                    {{field.action_name && field.aciton_type
                                                    !='view_documents'?field.action_name:field.aciton_type ==
                                                    'view_documents'?'Show Documents':'details'
                                                    | translate | async}}
                                                </a>
                                                }
                                              }
                                            </ng-container>
                                                }
                                              }
                                            </ng-container>
                                        </ng-container>
                                        @if (field.tooltip != undefined && field.tooltip && getFormattedValue(i, {key:field.tooltip})) {
                                        <div>
                                            {{field.tooltip}} : {{getFormattedValue(i, {key:field.tooltip})}} </div>
                                        }
                                    </td>
                                  }
                                </ng-container>
                                @if (_editableGridData.listBlocks.hasOwnProperty('actions') && _editableGridData.nestedFields.length>0) {
                                <td noWrap class="tdmiddle" class="fixed-column">
                                    <div
                                        [ngClass]="_editableGridData.listBlocks.actions[0].conditions.length>0 ? '_last_column_editable_grid':''">
                                        <ng-container>
                                          @for (act of _editableGridData.listBlocks.actions[0].conditions; track act; let iconIndex=$index; let lj=$last) {
                                            <ng-container>
                                                @if (getValue(group,act,i,l) && act.add && !this._editableGridData.last_row_add) {
                                                <span tabindex="0"
                                                    class="ca-actions pr-1" (click)="perRowAdd(i)"
                                                    (keydown.enter)="perRowAdd(i)">
                                                    <span class="fa fa-plus-circle"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i,l) && act.add && l && this._editableGridData.last_row_add) {
                                                <span tabindex="0"
                                                    class="ca-actions pr-1"
                                                    (click)="addRow(_editableGridData.items.length)"
                                                    (keydown.enter)="addRow(_editableGridData.items.length)">
                                                    <span class="fa fa-plus-circle"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.delete) {
                                                <span tabindex="0"
                                                    class="ca-actions p-2" (click)="removeRow(i)"
                                                    (keydown.enter)="removeRow(i)">
                                                    <span class="fa fa-trash"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.location) {
                                                <span tabindex="0"
                                                    class="ca-actions p-2" (click)="viewLocation(i)"
                                                    (keydown.enter)="viewLocation(i)">
                                                    <span class="fa fa-map-marker"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.copy) {
                                                <span tabindex="0"
                                                    class="ca-actions pl-1" (click)="copyRow(i)"
                                                    (keydown.enter)="copyRow(i)">
                                                    <span class="fa fa-copy"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.redirect && (act.permission_required == undefined || act.permission_required == false || rolePermissionService.checkAccessPermission(act.action_name, act.resource, act.application))) {
                                                <span tabindex="-1"
                                                    class="ca-actions pl-1" (click)="iconRedirect(group,act)"
                                                    (keydown.enter)="iconRedirect(group,act)">
                                                    <img [src]="act.src!=undefined &&act.src?act.src:'assets/images/icons/edit-emr.svg'"
                                                        style="width:26px;background: blue;border-radius: 4px;">
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.edit) {
                                                <span tabindex="0"
                                                    class="ca-actions pl-1" (click)="editRowOnPopup(i)"
                                                    (keydown.enter)="editRowOnPopup(i)">
                                                    <span class="fa fa-pencil"></span>
                                                </span>
                                                }
                                                @if (getValue(group,act,i) && act.flag) {
                                                <span tabindex="0"
                                                class="ca-actions pl-1" (click)="onFlagClick(i)"
                                                (keydown.enter)="onFlagClick(i)">
                                                <span [ngClass]="act.class?act.class:'grid-high-icon blue-emergency'"></span>
                                            </span>
                                                }
                                            @if (getValue(group,act,i) && act.info) {
                                            <span tabindex="0"
                                                class="ca-actions pl-1" (click)="onInfoClick(i)"
                                                (keydown.enter)="onInfoClick(i)">
                                                <span class="fa fa-info-circle"></span>
                                            </span>
                                            }
                                            @if (getValue(group,act,i) && act.decorator_based) {
                                            <span tabindex="0"
                                               class="ca-actions pl-1 text-center" [ngClass]="act.class?act.class:''" (click)="decoratorBased(act,i)"
                                                (keydown.enter)="decoratorBased(act,i)">
                                                <span class="{{act.icon}}" style="width:26px;background: blue;border-radius: 4px; color:white; padding: 5px;"></span>
                                            </span>
                                            }
                                            </ng-container>
                                            <ng-container>
                                              @if (_editableGridData.bookmarks!=undefined && _editableGridData.bookmarks.capability!=undefined && _editableGridData.bookmarks.capability.length!=undefined && _editableGridData.bookmarks.capability.length>0 && lj) {
                                                <ng-container>
                                                  @if (_editableGridData?.bookmarks?.capability?.[i]?.length > 0 && lj) {
                                                    @if (!isTableContextMenuActive(i)) {
                                                        <div class="table-row-actions d-inline-flex justify-content-center"
                                                            (click)="toggleTableContextMenu(i, $event)">
                                                            <i class="fa fa-ellipsis-v"></i>
                                                        </div>
                                                    }
                                                    @if (isTableContextMenuActive(i)) {
                                                        <div class="table-row-actions d-inline-flex justify-content-center"
                                                            [popover]="popTemplate" container="self"
                                                            containerClass="tabelcontextualmenu" [outsideClick]="true"
                                                            [isOpen]="true" placement="left top"
                                                            (onHidden)="isTableContextMenuOpen = null"
                                                            (click)="$event.stopPropagation();">
                                                            <i class="fa fa-ellipsis-v"></i>
                                                        </div>
                                                        <ng-template #popTemplate>
                                                            <div (click)="$event.stopPropagation()">
                                                                <ng-container>
                                                                    @for (action of _editableGridData.bookmarks.capability[i]; track action) {
                                                                        <button class="p-dropdown-item"
                                                                            (click)="emitEllipseId(group,action)">
                                                                            <i class="fa"></i>{{action.label| translate | async}}
                                                                        </button>
                                                                    }
                                                                </ng-container>
                                                            </div>
                                                        </ng-template>
                                                    }
                                                  }
                                                </ng-container>
                                              }
                                            </ng-container>
                                          }
                                        </ng-container>
                                    </div>
                                    <!-- <span *ngIf="getCopyPermission(i)" class="ca-actions pr-2" (click)="editRow(i)">
                                        <span class="fa fa-pencil"></span>
                                    </span>
                                    <span *ngIf="getCopyPermission(i)" class="ca-actions pl-2" (click)="removeRow(i)">
                                        <span class="fa fa-trash"></span>
                                    </span>  -->
                                </td>
                                }
                            </tr>
                          }
                        </ng-container>
                    </tbody>
                    }
                    @if (_editableGridData.nestedFields.length==0) {
                    <tbody>
                        <tr>
                            <td [attr.colspan]="getColspan()">
                                @if (!_editableGridData.isDataLoading) {
                                <div
                                    class="pt-3 kx-no-data kx-crush-txt-100 text-center">
                                    {{'No Records Available' | translate | async}}
                                </div>
                                }
                                @if (_editableGridData.isDataLoading) {
                                <div
                                    class="pt-3 kx-no-data kx-crush-txt-100 text-center">
                                    {{'Loading...' | translate | async}}
                                </div>
                                }
                            </td>
                        </tr>
                    </tbody>
                    }
                </table>
                }

            </div>
            }
            @if (this._editableGridData['activeField'] == 'tile' && this._editableGridData.nestedFields.length>0) {
            <div>
                <!-- <is-mobile-editable-grid [config]="{data:this._editableGridData.resourceData,fields:this._editableGridData.nestedFields,resource:this._editableGridData.whole_resource,form:getFormControls.controls}">

                </is-mobile-editable-grid>  -->
                <div class="row">
                    <div class="col-12">
                        <ng-container formArrayName="editableRows">
                          @for (group of getFormControls.controls; track group; let i=$index; let l=$last) {
                            <div class="col-12 col-sm-12 col-md-6 col-lg-4 float-left card-mobile-padding">
                                <div #commonCardLayout class="card card-view default-view no-border-card">
                                    <!-- <div class=""> -->
                                    <ng-template #popTemplate>
                                        <!-- <div> -->
                                        <ng-container>
                                          @if (_editableGridData.listBlocks.hasOwnProperty('actions') && _editableGridData.nestedFields.length>0) {
                                            <ng-container>
                                              @for (act of _editableGridData.listBlocks.actions[0].conditions; track act; let iconIndex=$index; let lj=$last) {
                                                <ng-container>
                                                    @if (getValue(group,act,i,l) && act.add && !this._editableGridData.last_row_add) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="perRowAdd(i)">
                                                            <span class="fa fa-plus-circle"></span> {{'Add New' |
                                                            translate | async}}
                                                        </button>
                                                    </div>
                                                    }
                                                    @if (getValue(group,act,i,l) && act.add && l && this._editableGridData.last_row_add) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="addRow(_editableGridData.items.length)">
                                                            <span class="fa fa-plus-circle"></span> {{'Add New' |
                                                            translate | async}}
                                                        </button>
                                                    </div>
                                                    }

                                                    @if (getValue(group,act,i) && act.delete) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="removeRow(i)">
                                                            <span class="fa fa-trash"></span> Delete
                                                        </button>
                                                    </div>
                                                    }

                                                    @if (getValue(group,act,i) && act.location) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="viewLocation(i)">
                                                            <span class="fa fa-map-marker"></span> Location
                                                        </button>
                                                    </div>
                                                    }

                                                    @if (getValue(group,act,i) && act.copy) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="copyRow(i)">
                                                            <span class="fa fa-copy"></span> Copy
                                                        </button>
                                                    </div>
                                                    }

                                                    <!-- <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            *ngIf="getValue(group,act,i) && act.redirect"
                                                            (click)="iconRedirect(i)">
                                                            <img [src]="act.src!=undefined &&act.src?act.src:'assets/images/icons/edit-emr.svg'"    style="width:26px;background: blue;border-radius: 4px;">
                                                        </button>
                                                    </div> -->

                                                    @if (getValue(group,act,i) && act.flag) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="onFlagClick(i)">
                                                            <span class="grid-high-icon blue-emergency"></span> Flag
                                                        </button>
                                                    </div>
                                                    }

                                                    @if (getValue(group,act,i) && act.info) {
                                                    <div>
                                                        <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                            (click)="onInfoClick(i)">
                                                            <span class="fa fa-info-circle"></span> Show Details
                                                        </button>
                                                    </div>
                                                    }

                                                    @if (getValue(group,act,i) && act.decorator_based) {
                                                        <div class="d-flex-inline">
                                                            <button class="p-dropdown-item ca-actions pr-1" triggers="focus"
                                                                [ngClass]="act.class?act.class:''"
                                                                (click)="decoratorBased(act,i)">
                                                                <span class="{{act.icon}}"></span>
                                                            </button>
                                                        </div>
                                                    }

                                                </ng-container>
                                                <ng-container>
                                                  @if (_editableGridData.bookmarks!=undefined && _editableGridData.bookmarks.capability!=undefined && _editableGridData.bookmarks.capability.length!=undefined && _editableGridData.bookmarks.capability.length>0 && lj) {
                                                    @if (_editableGridData.bookmarks.capability[i]) {
                                                      <ng-container>
                                                        @for (action of _editableGridData.bookmarks.capability[i]; track action) {
                                                          <button
                                                              triggers="focus" class="p-dropdown-item"
                                                              (click)="emitEllipseId(group,action)">
                                                              <i class="fa"></i>{{action.label| translate | async}}
                                                          </button>
                                                        }
                                                      </ng-container>
                                                    } @else {
                                                      <ng-container>
                                                        @for (action of _editableGridData.bookmarks.capability; track action) {
                                                          @if (rolePermissionService.checkAccessPermission(action.action_name, action.resource, action.application)) {
                                                          <button
                                                              triggers="focus" class="p-dropdown-item"
                                                              (click)="emitEllipseId(group,action)">
                                                              <i class="fa"></i>{{action.label| translate | async}}
                                                          </button>
                                                          }
                                                        }
                                                      </ng-container>
                                                    }
                                                  }
                                                </ng-container>
                                              }
                                            </ng-container>

                                            <!-- <span *ngIf="getCopyPermission(i)" class="ca-actions pr-2" (click)="editRow(i)">
                                                <span class="fa fa-pencil"></span>
                                            </span>
                                            <span *ngIf="getCopyPermission(i)" class="ca-actions pl-2" (click)="removeRow(i)">
                                                <span class="fa fa-trash"></span>
                                            </span>  -->
                                          }
                                        </ng-container>
                                        <!-- </div> -->
                                    </ng-template>
                                    @if (this._editableGridData && this._editableGridData.actions.length>0) {
                                    <div class="card-top-section">
                                        <div class="_card-actions-container">
                                            <div class="card-three-dots-container card-action table-row-actions">
                                                <i class="fa fa-ellipsis-v" area-hidden="true" [popover]="popTemplate"
                                                    placement="left top" container="self"
                                                    containerClass="tabelcontextualmenu" [outsideClick]="true"></i>
                                            </div>
                                        </div>

                                    </div>
                                    }
                                    <div class="card-middle-section" [id]="'card-md-sec-' +i" #getElementHeight>
                                        <div [formGroupName]="i" class="row">
                                            <ng-container [ngTemplateOutlet]="layoutRenderer"
                                                [ngTemplateOutletContext]="{i:i,group:group}">
                                            </ng-container>
                                        </div>
                                    </div>
                                    @if ('card-md-sec-' +i | getHeight:cardElem:'cardHeight':'height< 245?false:true') {
                                    <div class="_common-card-expand-collapse"
                                        (click)="commonCardLayout.classList.toggle('h-full')">
                                        <img src="assets/images/icon-expand.svg" class="_card-expand" loading="lazy"
                                            alt="">
                                    </div>
                                    }
                                    <!-- </div> -->
                                </div>
                            </div>
                          }



                        </ng-container>
                    </div>
                </div>
            </div>
            }
            <div class="row justify-content-center">
                <!-- <button type="submit" class="primary-btn submitButton mt-3"> 
                    Submit
                 </button> -->
                @if (_editableGridData.custom_button && _editableGridData.custom_button != undefined && _editableGridData.custom_button.length>0 && _editableGridData.items && _editableGridData.items.length != undefined &&  _editableGridData.items.length > 0 && checkItemSelection()) {
                <div class="">
                    @for (buttons of _editableGridData.custom_button; track buttons) {
                    <button type="button" class="primary-btn submitButton mt-3" (click)="onBottomButtonClicked(buttons)">
                        <i aria-hidden="true" [class]="buttons.class_name"></i>
                        <span>
                            {{buttons.label | translate | async}}
                        </span>
                    </button>
                    }
                </div>
                }
            </div>
        </form>
        }
    </div>
    @if (utilService.isMobile()) {
    <div class="_mobile-pagination-container" [hidden]="!_editableGridData.paging && _editableGridData.itemsCount>0">
        @if (_editableGridData.itemsCount > 0) {
        <dhs-pagination [gridConfig]="_editableGridData" [itemsCount]="_editableGridData.itemsCount"
            [limit]="_editableGridData.page_size" [startPage]="_editableGridData.page_no+1" (pageChange)="onPageChanged($event)" (onLimitChanges)="onLimit($event.target.value)" (onConfigChanges)="pageConfigChange($event)">
        </dhs-pagination>
        }
    </div>
    }
  }
</ng-container>

<ng-template #layoutRenderer let-i='i' let-group='group'>
  @if(_editableGridData.nestedFields[i]){
  <ng-container>
    <!--------------------------For select all container----------------->
    @if(_editableGridData.selectall){
    <ng-container scope="row" class="editable-tb-checkbox">
      <div class="col-12">
        <input type="checkbox" class="checkbox" [disabled]="disableSingleItem(group.value)"
          (change)="onItemChecked($event.target.checked, i,group)" [checked]="selectedIndices[i]">
      </div>
    </ng-container>
    }
    <!--------------------------For bar code container----------------->
    @if(_editableGridData.barcodeConfig && _editableGridData.barcodeConfig.isBarcodeText){
    <ng-container>
      <div class="col-6">
        <label id="barcode_label" class="control-label font-weight-bold" [innerHTML]="'BarCode' | translate | async">
        </label>
        <input id="bar_{{i}}" (keydown.enter)="barcodeRowScan($event.target.value, i)" type="textbox"
          class="form-control barcode">
      </div>
    </ng-container>
    }
    <!--------------------------For controls container----------------->
    <!-- converted *ngFor to @for -->
    @for (field of _editableGridData.nestedFields[i]; track field; let j=$index) {
    <ng-container>
      <div [ngClass]="field.controlType =='hidden'?'':'col-6'">
        @if(field.controlType !== 'hidden' && field.controlType !== 'checkbox' && field.label != null){
        <div>
          <label id="{{field.key}}_check" [attr.for]="field.key" class="control-label font-weight-bold"
            [ngClass]="field.required?'required':''" [innerHTML]="field.label | translate | async">
          </label>
          <!-- <sup [ngClass]="{'not-visible': !field.required}" class="req">*</sup> -->
        </div>
        }
        <ng-template #details>
          <!-----PopOver implementation-->
          @if(field && _editableGridData){
          <span>{{getDetails(field['key'],i)}}</span>
          }
        </ng-template>
        <ng-template #subs_details>
          <!-----PopOver implementation-->
          @if(field && _editableGridData){
          <span>{{getDetails(field['key'],i)}}</span>
          }
        </ng-template>
        <div scope="row" [ngClass]="field.controlType =='hidden'?'d-none':''">
          <ng-container [ngSwitch]="field.controlType">
            <ng-container *ngSwitchCase="'label'">
              <!-- this  adds classes with no. spans   -->
              @if(field.class_conditions && !field.grid_color_text &&
              commonService.getClass(this._editableGridData.items[i],field.class_conditions)!=undefined &&
              commonService.getClass(this._editableGridData.items[i],field.class_conditions)){
              <ng-container>
                <!-- converted *ngFor to @for -->
                @for (class_ of commonService.getClass(this._editableGridData.items[i],field.class_conditions).split(' '); track class_) {
                <ng-container>
                  <span [ngClass]="class_"> </span>
                </ng-container>
                }
              </ng-container>
              }
              @if(field.type == undefined){
              <label [controlName]="field.name"></label>
              }
              <!-- this span adds class for text color etc -->
              <span
                [ngClass]="field.grid_color_text!=undefined && field.grid_color_text && field.class_conditions?(this._editableGridData.items[i] | getClass:field.class_conditions):''">


                @if(field.type === 'datetime'){
                <span>
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateTimeFormat) :
                  ''}}
                </span>
                }
                @if(field.type === 'date'){
                <span>
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateFormat) : ''}}
                </span>
                }
                @if(field.type === 'time'){
                <span>
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | timeFormat) : ''}}
                </span>
                }
                @if(field.type === 'string' || field.type === 'String'){
                    @if (field.popover && getFormattedValue(i, field) && hoveredPopoverCell === field.key + '_' + i) {
                    <span [popover]="details" placement="top" container="self"
                      triggers="mouseenter:mouseleave"
                      (mouseleave)="hoveredPopoverCell = null"
                      (click)="field.conversion?changeControls(field,i):return;">{{
                      getFormattedValue(i, field) ? getFormattedValue(i, field) : getDefaultValue(field)}}
                    </span>
                    } @else {
                    <span
                      (mouseenter)="field.popover && getFormattedValue(i, field) ? hoveredPopoverCell = field.key + '_' + i : null"
                      (click)="field.conversion?changeControls(field,i):return;">{{
                      getFormattedValue(i, field) ? getFormattedValue(i, field) : getDefaultValue(field)}}
                    </span>
                    }
                }
                @if(field.type === 'number'){
                <span>
                  {{ getFormattedValue(i, field) ? getFormattedValue(i, field) : 0}}
                </span>
                }
                @if(field.type === 'monthYear'){
                <span
                  [ngClass]="field.class_conditions &&  !field.grid_color_text && commonService.getClass(this._editableGridData.items[i],field.class_conditions)!=undefined && commonService.getClass(this._editableGridData.items[i],field.class_conditions)">
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                  MonthYearFormat) : ''}}
                </span>
                }
                @if(field.type === 'boolean' || field.type === 'Boolean'){
                <span>
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field)) :
                  ''}}
                </span>
                }
                @if(field.type === 'composite'){
                <span>
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field)) :
                  ''}}
                </span>
                }
                @if (field.type === 'tat' || field.type === 'TAT') {
                <span [ngClass]="field.tatClass">
                </span>
                }
                @if (field.type === 'icon_pic') {
                 <span>
                      @for (image of field.image_conditions; track image) {
                         <ng-template #image_popover_data>
                         <span>{{image.popover_remark ? this._editableGridData.items[i][image.popover_remark] : image.popover_data| translate |async
                              }}</span>
                         </ng-template>
                        @if (checkBannerExpression(image.expression,this._editableGridData.items[i])) {
                        <img [popover]="field.show_popover?image_popover_data:''" class="Imageconditionflag" placement="top"
                             container="body" triggers="mouseenter:mouseleave" src="assets/images/{{image.path}}">
                            }
                       }
                    </span>
                  }
              </span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <dhs-form-question [action]="action" [validIn]="validIn" [insideGrid]="'true'" [index]="i"
                [question]="field" [form]="group" (valueChanged)="onValueChanged($event,group,i)">
              </dhs-form-question>
            </ng-container>
            <ng-container *ngSwitchCase="'link'">
              @if(field.changeable){
              <span>
                @if(checkExpression(i, field)){
                <a (click)="view_details(i,field)" class="text-decor" style="white-space: nowrap;">
                  {{ getFormattedValue(i, field) ? (getFormattedValue(i, field).length > 15 ? getFormattedValue(i,
                  field).slice(0, 15) + " ... " : getFormattedValue(i, field)) :'Search'}}
                </a>
                }
                @if(getFormattedValue(i, field)){
                <i aria-hidden="true" (click)="removeSubstitute(i,field)" class="fa fa-times-circle cursor-pointer"></i>
                }
              </span>
              }
              @if(!field.changeable){
              <span>
                @if(checkExpression(i, field)){
                <a (click)="view_details(i,field)" class="text-decor">
                  {{field.action_name && field.aciton_type
                  !='view_documents'?field.action_name:field.aciton_type ==
                  'view_documents'?'Show Documents':'details'
                  | translate | async}}
                </a>
                }
              </span>
              }
            </ng-container>

          </ng-container>
          @if(field.tooltip != undefined && field.tooltip && getFormattedValue(i, {key:field.tooltip})){
          <div>
            {{field.tooltip}} : {{getFormattedValue(i, {key:field.tooltip})}}
          </div>
          }
        </div>
      </div>
    </ng-container>
    }

  </ng-container>
  }
</ng-template>
<!-- <div dhs-modal></div> -->